import { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '@/lib/firebase';
import { motion } from 'framer-motion';
import { Lock, Mail, AlertCircle } from 'lucide-react';

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      onLogin(cred.user);
    } catch (err) {
      setError('Giriş başarısız. E-posta veya şifre hatalı.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-cream flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-sm"
      >
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-gradient-to-br from-brand-pink to-brand-blue flex items-center justify-center mb-4 overflow-hidden">
            <img
              src="https://customer-assets.emergentagent.com/job_ayz-modern-refresh/artifacts/v7g2xftl_bf9b2368-ab92-47b2-b299-567b89d2d406.jpeg"
              alt="AyzPlastik"
              className="w-full h-full object-cover"
            />
          </div>
          <h1 className="text-2xl font-bold text-brand-dark">Admin Paneli</h1>
          <p className="text-brand-dark/40 text-sm mt-1">AyzPlastik Yönetim</p>
        </div>

        <form onSubmit={handleLogin} data-testid="admin-login-form" className="p-6 rounded-2xl bg-white border border-slate-100 space-y-4">
          <div>
            <label className="block text-xs font-medium text-brand-dark/60 uppercase tracking-wider mb-1.5">
              E-posta
            </label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-brand-dark/30" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="admin-email-input"
                className="w-full h-11 pl-10 pr-4 rounded-xl border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-brand-blue/50"
                placeholder="admin@ayzplastics.com"
              />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-brand-dark/60 uppercase tracking-wider mb-1.5">
              Şifre
            </label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-brand-dark/30" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="admin-password-input"
                className="w-full h-11 pl-10 pr-4 rounded-xl border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-brand-blue/50"
                placeholder="Şifreniz"
              />
            </div>
          </div>

          {error && (
            <div data-testid="admin-login-error" className="flex items-center gap-2 text-red-500 text-sm">
              <AlertCircle size={14} />
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full h-11 rounded-full bg-brand-dark text-white text-sm font-medium hover:bg-brand-dark/90 transition-colors duration-200 disabled:opacity-50"
          >
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
